import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import {buildWidenPreviewImageFromVideoUrl} from "../../utils";

class VideoPlayer extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
        title: PropTypes.string,
        autoplay: PropTypes.bool,
        ratio: PropTypes.oneOf(['1x1', '4x3', '16x9', '21x9']),
        poster: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        initial: PropTypes.number
    };

    static defaultProps = {
        title: '',
        autoplay: false,
        ratio: '16x9',
        poster: false,
        initial: null
    };

    constructor(props) {
        super(props);
        this.state = {
            playing: true,
            hasSeeked: false,
            hasPreviewed: false,
            showControls: false,
            imgUrl: null,
        };
        this.playerRef = null;
    }

    // handlePreviewClick = () => {
    //     this.setState({ playing: true, hasPreviewed: true, showControls: true }, () => {
    //         if (this.playerRef) {
    //             this.playerRef.seekTo(0);
    //         }
    //     });
    // };

    // handleReady = () => {
    //     const { initial, poster, url } = this.props;
    //     if (poster) {
    //         const imageUrl = buildWidenPreviewImageFromVideoUrl(url);
    //         this.setState({imageUrl});
    //     }
    //
    //     if (this.playerRef && !this.state.hasSeeked) {
    //         const seekTime = poster ? 0 : initial;
    //         if (typeof seekTime === 'number' && seekTime >= 0) {
    //             try {
    //                 this.playerRef.seekTo(seekTime, "seconds");
    //                 this.setState({ playing: false, hasSeeked: true });
    //             } catch (e) {
    //                 console.error('seekTo failed:', e);
    //             }
    //         }
    //     }
    // };

    handlePlayPause = (isPlaying) => {
        this.setState({ playing: isPlaying });
    };

    handleMouseOverOut = () => {
        this.setState({isHovered: !this.state.isHovered});
    }

    render() {
        const { url, title, ratio, poster } = this.props;
        const { playing } = this.state;
        const isEmbedUrl = url.includes('view');
        const generatedPosterImage = buildWidenPreviewImageFromVideoUrl(url);
        console.log('generatedPosterImage', generatedPosterImage);

        const playBtn = (
            <svg
                width="130"
                height="130"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
                style={{ cursor: 'pointer' }}
            >
                <defs>
                    <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="black" floodOpacity="0.6" />
                    </filter>
                </defs>
                <polygon
                    points="35,25 75,50 35,75"
                    fill={'white'}
                    // stroke="white"
                    // strokeWidth="2"
                    filter="url(#shadow)"
                />
            </svg>
        )

        return (
            <div className="video-player">
                <div className={`ratio ratio-${ratio}`}>
                    {isEmbedUrl ? (
                        <iframe
                            src={url}
                            ref={el => {
                                if (el) {
                                    el.setAttribute('webkitAllowFullScreen', '');
                                    el.setAttribute('mozAllowFullScreen', '');
                                }
                            }}
                            allowFullScreen
                            frameBorder="0"
                            allowTransparency="true"
                            scrolling="0"
                            style={{border: '0'}}>
                        </iframe>
                    ) : (
                        <div>
                            <ReactPlayer
                                ref={(p) => (this.playerRef = p)}
                                url={url}
                                playing={playing}
                                controls={true}
                                playsinline
                                width="100%"
                                height="100%"
                                title={title}
                                // onReady={this.handleReady}
                                onPlay={() => this.handlePlayPause(true)}
                                onPause={() => this.handlePlayPause(false)}
                                onMouseOver={() => this.handleMouseOverOut()}
                                onMouseOut={() => this.handleMouseOverOut()}
                                light={poster ? poster : generatedPosterImage ? generatedPosterImage : false}
                                playIcon={playBtn}
                            />
                        </div>
                    )}

                </div>
            </div>
        );
    }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/pages/components/VideoPlayer.js